import {createViewConfig} from '@sail/engine';
import {tokens as $} from '@sail/tokens';

import type {View} from '../view';
import {css, baseline} from '../css';

export type CounterProps = View.IntrinsicElement<
  'span',
  {
    type: 'emphasized' | 'micro' | 'default';
    children?: React.ReactNode;
  }
>;

export const CounterConfig = createViewConfig({
  props: {} as CounterProps,
  name: 'Counter',
  flattens: true,
  defaults: {
    type: 'default',
  },
});

export const Counter = CounterConfig.createView('span', {
  uses: [baseline.css('x-middle')],
  css: {
    display: 'inline',
    whiteSpace: 'nowrap',
    stack: 'x',
    alignY: 'center',
    alignX: 'center',
    fontSize: '12px',
    height: 'space.250',
    lineHeight: '20px',
    fontWeight: 'semibold',
    borderRadius: 'rounded',
    paddingX: 'space.75',
  },
  variants: {
    type: {
      default: css({
        minWidth: 'space.250',
        color: 'text',
        backgroundColor: $['color.neutral.100'],
      }),
      emphasized: css({
        minWidth: 'space.250',
        textColor: $['color.neutral.0'],
        backgroundColor: $['color.feedback.critical.400'],
      }),
      micro: [
        css({
          height: 'space.75',
          width: 'space.75',
          borderRadius: 'rounded',
          backgroundColor: $['color.feedback.critical.400'],
          border: '2px solid',
          borderColor: $['color.background.surface'],
          padding: 'space.0',
          boxSizing: 'content-box',
        }),
        css({
          textIndent: '-9999px',
        }),
      ],
    },
  },
});
